import { render } from "./GridsPage.vue?vue&type=template&id=34a6e164&ts=true"
import script from "./GridsPage.vue?vue&type=script&lang=ts"
export * from "./GridsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__